module.exports = __webpack_public_path__ + "static/es-logo100-web-4d3b4bd3353fa8f5543bb2ab6b320ae2.svg";